import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { DeviceSettingListActions, DeviceSettingListActionTypes } from '../actions/device-setting-list.actions';
import {DeviceSettingList} from '../device-mgt.model';

export interface State extends EntityState<DeviceSettingList> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<DeviceSettingList> = createEntityAdapter<DeviceSettingList>({
  selectId: info => info.dcode
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: DeviceSettingListActions
): State {
  switch (action.type) {
    case DeviceSettingListActionTypes.AddDeviceSettingList: {
      return adapter.addOne(action.payload.deviceSettingList, state);
    }

    case DeviceSettingListActionTypes.UpsertDeviceSettingList: {
      return adapter.upsertOne(action.payload.deviceSettingList, state);
    }

    case DeviceSettingListActionTypes.AddDeviceSettingLists: {
      return adapter.addMany(action.payload.deviceSettingLists, state);
    }

    case DeviceSettingListActionTypes.UpsertDeviceSettingLists: {
      return adapter.upsertMany(action.payload.deviceSettingLists, state);
    }

    case DeviceSettingListActionTypes.UpdateDeviceSettingList: {
      return adapter.updateOne(action.payload.deviceSettingList, state);
    }

    case DeviceSettingListActionTypes.UpdateDeviceSettingLists: {
      return adapter.updateMany(action.payload.deviceSettingLists, state);
    }

    case DeviceSettingListActionTypes.GetDeleteDeviceSettingList: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceSettingListActionTypes.DeleteDeviceSettingList: {
      return adapter.removeOne(action.payload.id, {...state, Loaded: true, Loading: false});
    }

    case DeviceSettingListActionTypes.DeleteDeviceSettingLists: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case DeviceSettingListActionTypes.LoadDeviceSettingLists: {
      return adapter.setAll(action.payload, {
        ...state,
        Loaded: true,
        Loading: false
      });
    }

    case DeviceSettingListActionTypes.ClearDeviceSettingLists: {
      return adapter.removeAll(state);
    }

    case DeviceSettingListActionTypes.GetDeviceSettingLists: {
      return adapter.removeAll({
        ...state,
        Loaded: false,
        Loading: true
      });
    }

    case DeviceSettingListActionTypes.GetDeviceSettingListsFail: {
      return {...state, Loaded: true, Loading: false };
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
